import { createSlice } from "@reduxjs/toolkit";

const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    routes: false,
    zoomPercentage: 100,
    disability: "",
    tabIndex: 0,
  },
  reducers: {
    setSettings: (state, action) => {
      state.routes = action.payload.routes;
      state.zoomPercentage = action.payload.zoomPercentage;
      state.disability = action.payload.disability;
    },
    updateRoutes: (state, action) => {
      state.routes = action.payload;
    },
    updateZoomPercentage: (state, action) => {
      state.zoomPercentage = action.payload;
    },
    updateDisability: (state, action) => {
      state.disability = action.payload;
    },
    setTabIndex: (state, action) => {
      state.tabIndex = action.payload;
    },
  },
});

export const {
  setSettings,
  updateRoutes,
  updateZoomPercentage,
  updateDisability,
  setTabIndex,
} = settingsSlice.actions;
export default settingsSlice.reducer;
